/* Cellmula Skincare — Theme JavaScript */

(function() {
  'use strict';

  /* --- Sticky Header Scroll Detection --- */
  var stickyHeader = document.querySelector('.header-wrapper--sticky');
  if (stickyHeader) {
    window.addEventListener('scroll', function() {
      if (window.scrollY > 60) {
        stickyHeader.classList.add('is-scrolled');
      } else {
        stickyHeader.classList.remove('is-scrolled');
      }
    }, { passive: true });
  }

  /* --- Product Thumbnails --- */
  document.querySelectorAll('[data-product-thumbnail]').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      var imgSrc = this.querySelector('img').getAttribute('data-full-src') ||
                   this.querySelector('img').src;
      var mainImage = document.querySelector('[data-main-image]');
      if (mainImage) {
        mainImage.querySelector('img').src = imgSrc;
      }
      document.querySelectorAll('[data-product-thumbnail]').forEach(function(t) {
        t.classList.remove('is-active');
      });
      this.classList.add('is-active');
    });
  });

  /* --- Product Variant Selector --- */
  document.querySelectorAll('[data-variant-select]').forEach(function(select) {
    select.addEventListener('change', function() {
      var form = this.closest('form');
      var variantInput = form.querySelector('input[name="id"]');
      if (variantInput) {
        variantInput.value = this.value;
      }
    });
  });

})();
